
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
    Box,
    Typography,
    CircularProgress,
    Grid,
    TextField,
    Autocomplete,
    Modal,
    MenuItem,
    Button,
    Container,
    CardContent,
    Card,
    Pagination,
    FormGroup, FormControlLabel, Checkbox
} from '@mui/material';

import { useAxios } from '../../../../context/AxiosHookContext';
import { cargos } from '../../../../utils/lists';
import { useNotification } from "../../../../context/NotificationContext";


export default function AddPersonalitiesModal({ onClose, openModalEdit, funcionario = {}, invitation }) {

    const axios = useAxios();
    const [selectedValuesToEdit, selectValuesToEdit] = useState(funcionario);
    const [filterName, setFilterName] = useState("");
    const [openOrganizationList, setOpenOrganizationList] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingOrg, setLoadingOrg] = useState(false);
    const [organizationList, setorganizationList] = useState([]);
    const [personalitiesList, setPersonalitiesList] = useState([]);
    const { showSnackbar } = useNotification();
    const [personalityName, setPersonalityName] = useState("")
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [organizationSelected, setOrganizationSelected] = useState({ _id: 0, nombre: "" });
    const [totalPages, setTotalPages] = useState(1);
    const [selectedList, setSelectedList] = useState([])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const selectPersonality = (functionario) => {
        // Crear una copia mutable de la lista seleccionada
        const updatedList = [...selectedList];

        // Encontrar el índice del elemento en la lista
        const index = updatedList.findIndex(selectedOne => selectedOne._id === functionario._id);

        if (index === -1) {
            // Si no existe, agregarlo al final
            updatedList.push(functionario);
        } else {
            // Si ya existe, eliminarlo
            updatedList.splice(index, 1);
        }

        // Actualizar el estado con la nueva lista
        setSelectedList(updatedList);
    };


    const saveSelected = async () => {
        try {

            setIsSubmitting(true);

            for (const funcionario of selectedList) {

                const body = {
                    funcionario: funcionario,
                    invitationId: invitation._id,
                    invitationDescription: invitation.description
                }

                try {

                    const response = await axios.post("/invitations/record", body);
                    console.log(response)

                } catch (error) {
                    continue;
                }

            }
            showSnackbar({ severity: "success", title: "Registros", message: "Registros agregados de forma exitosa" });
            setSelectedList([])
        } catch (error) {
            showSnackbar({ severity: "error", title: "Error de registros", message: "Ha ocurrido un error al guardar los registros seleccionados" })
        } finally {
            setIsSubmitting(false)
        }
    }

    const getPersonalities = useCallback(async () => {
        try {
            const api = `/personalities?page=${page}&limit=10${personalityName ? `&fullName=${personalityName}` : ''}${organizationSelected ? `&institucionId=${organizationSelected._id}` : ''}`
            setPersonalitiesList([])
            setLoading(true);
            const { data } = await axios.get(api);
            setPersonalitiesList(data?.data?.list);
            setTotalPages(data?.data?.total_pages);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, setLoading, page, personalityName, organizationSelected]);


    const getOrganizations = useCallback(async () => {
        try {
            const organizationApi = `/personalities/organizations?page=${1}&limit=30${filterName ? `&nombre=${filterName}` : ''}`
            setorganizationList([])
            setLoadingOrg(true);
            const { data } = await axios.get(organizationApi);
            setorganizationList(data?.data?.list);

        } catch (error) {
            console.log(error);
        } finally {
            setLoadingOrg(false);
        }
    }, [axios, setLoadingOrg, filterName]);


    useEffect(() => {
        if (filterName.length > 0) {
            getOrganizations()
        }
    }, [filterName])

    useEffect(() => {
        getPersonalities();
    }, [organizationSelected, personalityName, page])


    return (
        <Modal
            open={openModalEdit}
            onClose={() => { onClose() }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >

            <Container sx={{ height: "85vh", position: "relative", background: "white", marginTop: 5, borderRadius: 2, overflowY: "auto", padding: 3 }}>

                <Grid item container alignItems={"center"} spacing={2} p={1} >

                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            type="submit"
                            fullWidth
                            endIcon={
                                <span style={{ fontSize: 14 }}>{selectedList.length}</span>
                            }
                            onClick={saveSelected}
                        >
                            {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                            {isSubmitting ? 'Guardando' : 'Guardar seleccionadas'}
                        </Button>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Nombre: "
                            value={personalityName}
                            onChange={(e) => {
                                setPersonalityName(e.target.value)
                            }}
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            size="small"
                            fullWidth
                            id="support_assigned"
                            open={openOrganizationList}
                            onOpen={() => {
                                setOpenOrganizationList(true);
                            }}
                            onClose={() => {
                                setOpenOrganizationList(false);
                            }}
                            isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
                            getOptionLabel={(option) =>
                                option.nombre
                            }
                            options={organizationList}
                            defaultValue={{ _id: organizationSelected?._id || "", nombre: organizationSelected?.nombre || "" }}
                            loading={loading}
                            onChange={(_e, value) => {
                                if (!value) {
                                    setOrganizationSelected(null)
                                    setFilterName("")
                                    setPersonalityName("")
                                }
                                setOrganizationSelected(value)
                                setPage(1)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    size="small"
                                    {...params}
                                    label="Institución"
                                    onChange={(e) => {
                                        setFilterName(e.target.value)
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loadingOrg ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                        />

                    </Grid>

                </Grid>

                {
                    personalitiesList?.map((personality) =>
                        <FuncionarioCard funcionario={personality} selectPersonality={selectPersonality} selectedList={selectedList} />
                    )
                }

                {
                    loading === true &&
                    <Grid sm={12} textAlign={"center"} mt={12}>
                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />
                    </Grid>
                }

                {
                    personalitiesList.length > 0 &&
                    <Grid sm={12} textAlign={"left"} mb={2}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handleChangePage}
                            sx={{ color: "#ffe7d9", marginBottom: 5 }}
                        />
                    </Grid>
                }

            </Container >
        </Modal>
    )
}

const FuncionarioCard = ({ funcionario = {}, selectedList = [], selectPersonality = (personality) => { true } }) => {

    return (
        <Card sx={{
            border: "1px solid #dfd2d2", borderRadius: 2, margin: 2,
            borderTop: `3px solid ${funcionario?.estado ? '#3b5a1e' : '#6da33c'}`,
            borderRight: `3px solid ${funcionario?.estado ? '#3b5a1e' : '#6da33c'}`
        }}>
            <CardContent sx={{ cursor: "pointer" }} onClick={() => {
                selectPersonality(funcionario);
            }}>
                <Grid container spacing={2}>

                    <Grid container item xs={2} alignItems={"center"}>

                        <FormGroup>
                            <FormControlLabel control={<Checkbox value={true} checked={selectedList.some(cardOne => cardOne._id === funcionario._id)} />} />
                        </FormGroup>


                        <img src={funcionario.foto || "https://observicios.gob.do/back/api/funcionarios/6391/foto"} alt="foto-funcionario" style={{
                            objectFit: "contain",
                            height: 100,
                            width: 100,
                            minHeight: 100,
                            minWidth: 100,
                            borderRadius: "100%",
                            border: `solid 4px ${funcionario?.historialFuncionario[0]?.fechaFin ? '#3b5a1e' : '#6da33c'}`
                        }} />
                    </Grid>

                    <Grid item container xs={10} sx={{ position: "relative" }}>

                        <Box sx={{
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "white",
                            backgroundColor: funcionario?.historialFuncionario[0]?.fechaFin ? "#3b5a1e" : "#6da33c",
                            width: 200,
                            position: "absolute",
                            right: 0,
                            height: 30,
                            borderRadius: 10,
                            fontWeight: "700",
                            letterSpacing: 1
                        }}>
                            {funcionario?.historialFuncionario[0]?.fechaFin ? "Inactivo" : "Activo"}
                        </Box>

                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{ fontSize: "1.40rem", fontWeight: "700", color: "#5d5151" }}>{funcionario.fullName}</Typography>
                            <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>{funcionario.institucion}</Typography>
                        </Grid>

                        <Grid container item xs={12} spacing={2}>

                            <Grid container item xs={6} sx={{}}>

                                <Grid container item xs={5} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }}>Cargo:</Typography>
                                </Grid>

                                <Grid container item xs={7} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>{funcionario?.cargo || "N/A"}</Typography>
                                </Grid>

                            </Grid>

                            <Grid container item xs={6} sx={{}}>

                                <Grid container item xs={5} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }}>Fecha de ingreso:</Typography>
                                </Grid>

                                <Grid container item xs={7} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>
                                        {funcionario?.historialFuncionario[0]?.fechaInicio || "N/A"}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>


                        <Grid container item xs={12} spacing={2} justifyContent={"space-between"}>

                            <Grid container item xs={6} sx={{}}>

                                <Grid container item xs={5} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }} >Correo electrónico:</Typography>
                                </Grid>

                                <Grid container item xs={7} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151", width: 50 }} flexWrap={true}>{funcionario?.email || "N/A"}</Typography>
                                </Grid>

                            </Grid>

                            <Grid container item xs={6} sx={{}}>

                                <Grid container item xs={5} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "1rem", fontWeight: "600" }}>Teléfono:</Typography>
                                </Grid>

                                <Grid container item xs={7} sx={{}}>
                                    <Typography variant="body1" sx={{ fontSize: "0.9rem", fontWeight: "600", color: "#5d5151" }}>
                                        {funcionario?.telefono?.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-888-9566') || "N/A"} Ext.: {funcionario.extension || "N/A"}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>

                </Grid>

            </CardContent>

        </Card >
    );
};